module.exports = __webpack_public_path__ + "img/better.4a9eaa4e.png";